<template>
    <div id="Container_ePharmacyBase">
      <h4 class="page-title text-truncate"> {{ $t('ePharmacyBase.ePharmacyTitle') }} - 
        <span v-if="this.PatientTitle.fullName">{{this.PatientTitle.fullName+' '}}</span> -
        <span v-if="this.$route.params.id">{{this.$route.params.id}}</span>
        <span v-if="this.PatientTitle.dob"> - {{ $t('Shared.Dob') }} {{this.PatientTitle.dob}}</span>
        <span v-if="this.PatientTitle.ageFormatted"> {{ $t('Shared.Age') }} {{this.PatientTitle.ageFormatted}}</span>
      </h4>
      <iframe allow-same-origin allow-forms id="iframe" name="iframe" width="100%" height="800px"  frameborder="0">

      </iframe>       
      
    </div>
 </template>
 
 <script>
 import EnumService from '@/services/enum.service';
 import DBFunctions from '@/common/DBFunctions.js'
 import moment from "moment";
 import NewCropService from '@/services/newcrop.service' 
 import ShowMessage from '@/components/messages/ShowMessage.js';

 //import { EventBus } from '@/event-bus.js';
 
export default {
  name: 'ePharmacyBase',
  props: {Origin:String},
  mixins: [DBFunctions, ShowMessage],


  data(){
    return{
      PatientTitle:{      
        programName:'',
        fullName:'',
        admitDate:'',
        dischargeDate:'',
        age:"",
        dob:''
      },
      OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
      },
    }
  },

  methods: {
    async GetPatientByCode(){
      var infoList = await this.getInfoTitle(this.$route.params.id);
      if(infoList.length > 0){
          this.PatientTitle.programName = '';
          this.PatientTitle.admitDate = '';
          this.PatientTitle.dischargeDate = '';
          this.PatientTitle.age = infoList[0].age;
          this.PatientTitle.ageFormatted = infoList[0].ageFormatted;
          if(infoList[0].dob){
              this.PatientTitle.dob = moment(infoList[0].dob).format('MM/DD/YYYY');
          }   
          this.PatientTitle.fullName = infoList[0].firstname + ' '+ infoList[0].lastname;
      }
    },

    async CreateNewCrop(){
      this.$emit('load', true);
      await NewCropService.sendRequest(this.$route.params.id).then(response => {
        const form = document.createElement('form');
        let iframe = document.getElementById("iframe");
        form.method = response.data.method;
        form.target = "iframe";
        form.action = response.data.url
        const hiddenField = document.createElement('textarea');
        hiddenField.style.visibility = "hidden";
        hiddenField.name = "RxInput";
        hiddenField.id = "RxInput";
        hiddenField.value = response.data.xml;
        form.appendChild(hiddenField);
        iframe.appendChild(form);
        form.submit();		 
      }).catch(error => {
        if (!error.response) {                      
          this.showMessage(this.$t('ePharmacyBase.ePharmacyTitle'),this.$t('Msg.retrieveInfo'),"error");
        }                      
        else if(error.response.status === 400 ){
          this.showMessage(this.$t('ePharmacyBase.ePharmacyTitle'),error.response.data,"error");
        } else if(error.response.status === 500){
          this.showMessage(this.$t('ePharmacyBase.ePharmacyTitle'),this.$t('Msg.ThereWereSomeError'),"error");
        } else{
          this.showMessage(this.$t('ePharmacyBase.ePharmacyTitle'),error.response.data,"error");
        }
      })
    }
  },
  created() {
    this.GetPatientByCode();
    this.CreateNewCrop();
  },
  async mounted(){
   /* this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems;
    this.OptionsRightMenu.Mode = true;
    this.OptionsRightMenu.visible = true; 
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
    this.$emit('getBtnRightMenu', this.OptionsRightMenu);*/

    this.OptionsRightMenu.visible = true;
    this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
    this.$emit('getBtnRightMenu', this.OptionsRightMenu);
  }
}
 </script>
 
 
 